// Dave-Tech mega menu behaviour.
// Default view: overview of all groups. Hover previews a left-side group.
// Click a left-side group to pin it; click X to return to overview.
(function () {
  function getTargetId(tab) {
    return tab && (tab.getAttribute('data-target') || (tab.getAttribute('href') || '').replace('#', ''));
  }

  function setTabs(menu, activeTab) {
    menu.querySelectorAll('[data-dt-mega-tab]').forEach(function (item) {
      var isActive = activeTab && item === activeTab;
      item.classList.toggle('is-active', !!isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function setPanels(menu, targetId) {
    var overview = menu.querySelector('[data-dt-mega-overview]');
    var panels = menu.querySelectorAll('.dt-mega-menu__group');

    if (overview) {
      var showOverview = !targetId;
      overview.classList.toggle('is-active', showOverview);
      overview.hidden = !showOverview;
    }

    panels.forEach(function (panel) {
      var isActive = targetId && panel.id === targetId;
      panel.classList.toggle('is-active', !!isActive);
      panel.hidden = !isActive;
      if (isActive) {
        panel.scrollTop = 0;
        var links = panel.querySelector('.dt-mega-menu__links');
        if (links) links.scrollTop = 0;
      }
    });

    var body = menu.querySelector('.dt-mega-menu__body');
    if (body) body.scrollTop = 0;
  }

  function showOverview(menu) {
    if (!menu || menu.dataset.dtMegaPinned === 'true') return;
    menu.classList.remove('is-previewing', 'is-pinned');
    setTabs(menu, null);
    setPanels(menu, null);
  }

  function previewTab(menu, tab) {
    if (!menu || !tab || menu.dataset.dtMegaPinned === 'true') return;
    var targetId = getTargetId(tab);
    if (!targetId) return;
    menu.classList.add('is-previewing');
    menu.classList.remove('is-pinned');
    setTabs(menu, tab);
    setPanels(menu, targetId);
  }

  function pinTab(menu, tab) {
    if (!menu || !tab) return;
    var targetId = getTargetId(tab);
    if (!targetId) return;
    menu.dataset.dtMegaPinned = 'true';
    menu.dataset.dtMegaPinnedTarget = targetId;
    menu.classList.add('is-pinned');
    menu.classList.remove('is-previewing');
    setTabs(menu, tab);
    setPanels(menu, targetId);
  }

  function unpin(menu) {
    if (!menu) return;
    menu.dataset.dtMegaPinned = 'false';
    menu.dataset.dtMegaPinnedTarget = '';
    menu.classList.remove('is-pinned', 'is-previewing');
    setTabs(menu, null);
    setPanels(menu, null);
  }

  function initMegaMenu(menu) {
    if (!menu || menu.dataset.dtMegaInitialised === 'true') return;
    menu.dataset.dtMegaInitialised = 'true';
    menu.dataset.dtMegaPinned = 'false';

    var tabs = menu.querySelectorAll('[data-dt-mega-tab]');
    var resetButtons = menu.querySelectorAll('[data-dt-mega-reset]');

    tabs.forEach(function (tab) {
      tab.addEventListener('mouseenter', function () {
        previewTab(menu, tab);
      });

      tab.addEventListener('mouseleave', function () {
        showOverview(menu);
      });

      tab.addEventListener('focus', function () {
        previewTab(menu, tab);
      });

      tab.addEventListener('click', function (event) {
        event.preventDefault();
        pinTab(menu, tab);
      });
    });

    resetButtons.forEach(function (reset) {
      reset.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });

      reset.addEventListener('mousedown', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });

      reset.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        unpin(menu);
      });
    });

    menu.addEventListener('toggle', function () {
      if (menu.open) {
        unpin(menu);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.open && menu.dataset.dtMegaPinned === 'true') {
        unpin(menu);
      }
    });

    unpin(menu);
  }

  function initAll() {
    document.querySelectorAll('.dt-mega-menu').forEach(initMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
